// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3O3lI","rootSmall":"AddTileButton_rootSmall__Jeeu-"};